/**
 * Which portal pathway an application originated from.  Mirrors PortalApplicationSourceValues
 * on the API (LA-22626); the values are compared as strings, so they must stay in step.
 */
export const PortalApplicationSource = {
    statewide: 'Statewide Portal',
    agency: 'Agency Portal'
} as const;

export class Application {
    applicationId?: number | undefined;
    selectedProgramIds: number[] | undefined;
    selectedProviderIds: number[] | undefined;
    isPersonalInfoComplete: boolean | undefined;
    isBackgroundComplete: boolean | undefined;
    isEducationComplete: boolean | undefined;
    isDisclosureComplete: boolean | undefined;
    isSubmitted: boolean | undefined;
    submitDate?: Date | undefined;

    /** Undefined for applications created before the pathway was recorded. */
    portalApplicationSource?: string | undefined;

    constructor(options?: Partial<Application>) {
        Object.assign(this, options);
    }
}
